import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { ToggleButton } from '@mui/material';

function ShowDeletedToggler({
  content, onChange, disabled, value,
}) {
  const onClick = useCallback(
    (e) => onChange(e, !value),
    [onChange, value],
  );
  return (
    <ToggleButton
      value="show_deleted"
      selected={value}
      color="info"
      size="small"
      disabled={disabled}
      onChange={onClick}
      title={content}
    >
      <FontAwesomeIcon icon={value ? faEye : faEyeSlash} />
    </ToggleButton>
  );
}

ShowDeletedToggler.propTypes = {
  value: PropTypes.bool.isRequired,
  content: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ShowDeletedToggler.defaultProps = {
  content: 'Показувати видаленні',
  disabled: false,
};

export default ShowDeletedToggler;
